import { z } from 'zod';

// src/contracts/common.ts
var UUID_V7_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-7[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/;
var ISO_DATE_TIME_REGEX = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/;
var DATE_ONLY_REGEX = /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/;
var BASE64URL_REGEX = /^[A-Za-z0-9_-]*$/;
var B64_ALPHABET = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_";
function isCanonicalBase64Url(text) {
  const rest = text.length % 4;
  if (rest === 0) return true;
  if (rest === 1) return false;
  const v = B64_ALPHABET.indexOf(text[text.length - 1]);
  return v >= 0 && (v & (rest === 2 ? 15 : 3)) === 0;
}
var uuidSchema = z.string().regex(UUID_V7_REGEX, "expected lowercase UUIDv7");
var isoDateTimeSchema = z.string().regex(ISO_DATE_TIME_REGEX, "expected ISO 8601 UTC timestamp with milliseconds").refine((s) => !Number.isNaN(Date.parse(s)), "invalid timestamp");
var dateOnlySchema = z.string().regex(DATE_ONLY_REGEX, "expected YYYY-MM-DD");
var base64UrlSchema = z.string().regex(BASE64URL_REGEX, "expected base64url without padding").refine(isCanonicalBase64Url, "non-canonical base64url (bad length or non-zero trailing bits)");
function base64UrlLength(n) {
  return Math.ceil(n * 4 / 3);
}
function base64UrlDecodedLength(len) {
  return Math.floor(len * 3 / 4);
}
function base64UrlBytesSchema(n) {
  return base64UrlSchema.length(base64UrlLength(n), `expected base64url of ${n} bytes`);
}
var key32Schema = base64UrlBytesSchema(32);
var AUTHOR_KINDS = ["user", "guest", "agent"];
var authorKindSchema = z.enum(AUTHOR_KINDS);
var DOC_KINDS = ["account", "notebook", "note", "space"];
var docKindSchema = z.enum(DOC_KINDS);
var NOTEBOOK_MODES = ["private", "agent"];
var notebookModeSchema = z.enum(NOTEBOOK_MODES);

export { AUTHOR_KINDS, BASE64URL_REGEX, DATE_ONLY_REGEX, DOC_KINDS, ISO_DATE_TIME_REGEX, NOTEBOOK_MODES, UUID_V7_REGEX, authorKindSchema, base64UrlBytesSchema, base64UrlDecodedLength, base64UrlLength, base64UrlSchema, dateOnlySchema, docKindSchema, isCanonicalBase64Url, isoDateTimeSchema, key32Schema, notebookModeSchema, uuidSchema };
//# sourceMappingURL=chunk-EWGKAU72.js.map
//# sourceMappingURL=chunk-EWGKAU72.js.map